import { useWorkflows, workflowSelector } from '@/store/workflows';
import { NodeShell } from '../NodeShell';
import type { NodeProps } from '@xyflow/react';

export function FinalizedNode({ data }: NodeProps & { data: { workflowId: string } }) {
  const wf = useWorkflows(workflowSelector(data.workflowId));
  if (!wf) return null;
  return (
    <NodeShell title="Clip Finalized" state={wf.states.finalized} width={180}>
      <div className="text-[11px] text-ink-500">saved to R2 → editing</div>
    </NodeShell>
  );
}
